import {
  CombinationStatus,
  ContractAnalysisType,
  Contract
} from '../types/types'

export const getCombinationStatus = ({
  labApproval,
  approvalComment
}: ContractAnalysisType): CombinationStatus => {
  if (labApproval === true) return 'approved'
  if (labApproval === false && approvalComment != null) return 'declined'
  return 'awaiting'
}

export type ContractStatus = {
  label: string
  color: 'success' | 'warning' | 'neutral'
}

export const getContractStatus = (
  contract: Pick<Contract, 'startDate' | 'endDate'>
): ContractStatus => {
  const now = Date.now()
  const start = contract.startDate
    ? new Date(contract.startDate).getTime()
    : undefined
  const end = contract.endDate
    ? new Date(contract.endDate).getTime()
    : undefined

  if (start != null && start > now) {
    return { label: 'Kommende', color: 'neutral' }
  }
  if (end != null && end < now) return { label: 'Utløpt', color: 'warning' }
  return { label: 'Aktiv', color: 'success' }
}

export const getCombinationCountText = (
  total: number | undefined,
  approved?: number
): string => {
  if (total == null) return '-'
  if (approved == null) return total.toString()
  return `${total} (${approved} godkjent)`
}
